<template>
  <div class="page">
    <div class="container py-5">
      <div class="row">
        <div class="col-md-12">
          <div class="card text-center">
            <div class="card-body">
              <img src="../assets/img/success.png"  alt="Success" class="img-fluid mb-4" style="max-width: 150px;">
              <h2 class="card-title mb-3">Payment Success!</h2>
              <p class="card-text mb-4">Thank you for your purchase.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TestSuccessScreen",
  beforeMount() {
    this.recordTransaction();
  },
  methods: {
    async recordTransaction(){
      let parsedReference = JSON.parse(window.atob(this.$route.query.ClientRef));
      console.log(parsedReference);
      const payload = {
        accountNumber: this.$route.query.Cell,
        quoteNumber: parsedReference.quoteNumber,
        amount: parsedReference.amount,
        discountAmount: parsedReference.discountAmount,
      };

      this.$store.commit('setLoadingState', true);
      return this.$store.dispatch('receiveIntegratedPayment',payload)
          .finally(()=> this.$store.commit('setLoadingState', false))
    }
  }
}
</script>